export default () => ({
    inVRMode: false,
    mode: 'edit',
    selectedEntityId: null,
    inAnimationMode: false,
    animationContext: {},
});
